import React from "react";
import AppBody from "../components/AppBody";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import {
  createTrainerSkill,
  getSkills,
} from "../../actions/trainer/trainer_skills_action";
import CreateCategoryModel from "../admin/certification/CreateCategoryModel";
import { categoryList } from "../../actions/admin/certification/category_action";
import { useEffect } from "react";
import CreateSkillModel from "./CreateSkillModel";

const AddTrainerSkills = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.trainerSkillReducer);
  const categoryState = useSelector((state) => state.categoryReducer);
  const [categoyModel, setCategoyModel] = useState(false);
  const [skillModel, setSkillModel] = useState(false);

  const [trainerSkill, setTrainerSkill] = useState({
    skill_id: "",
    rate_per_hours: "",
    experience: "",
    type: "",
    category_id: "",
  });

  useEffect(() => {
    dispatch(categoryList());
  }, []);

  const handleFormSubmit = () => {
    dispatch(createTrainerSkill(trainerSkill));
  };

  if (state.is_done) {
    toast("Record added successfully!", {
      type: "success",
      position: "top-center",
    });
    navigate("/trainer/skill-list");
  }
  const handelClosePopup = () => {
    setCategoyModel(false);
    setSkillModel(false);
    dispatch(getSkills({ category_id: trainerSkill.category_id }));
    dispatch(categoryList());
  };
   console.log(skillModel);

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/trainer/skill-list"}
                  className="d-inline-block mt-2"
                >
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Add Skill
                </h4>
              </div>
              <div className="card-body  p-4 w-100 border-0 ">
                <ToastContainer />
                <form>
                  {categoyModel && (
                    <CreateCategoryModel
                      show={categoyModel}
                      isAction={1}
                      handelUpdateShow={() => handelClosePopup()}
                    />
                  )}

                  {skillModel && (
                    <CreateSkillModel
                      show={skillModel}
                      category={trainerSkill.category_id}
                      handelUpdateShow={() => handelClosePopup()}
                    />
                  )}

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Category
                        </label>
                        <select
                          className="form-control"
                          name={"category_id"}
                          onChange={(e) => {
                            setTrainerSkill({
                              ...trainerSkill,
                              category_id: e.target.value,
                            });
                            dispatch(
                              getSkills({ category_id: e.target.value })
                            );
                          }}
                        >
                          <option>Select Category</option>
                          {categoryState.list &&
                            categoryState.list.map((li, i) => (
                              <option value={li.id}>{li.name}</option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.category_id
                            ? state.errors.category_id
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add Category"
                        onClick={() => setCategoyModel(true)}
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Skill
                        </label>
                        <select
                          className="form-control"
                          name={"skill_id"}
                          onChange={(e) =>
                            setTrainerSkill({
                              ...trainerSkill,
                              skill_id: e.target.value,
                            })
                          }
                        >
                          <option>Select Skill</option>
                          {state.skills &&
                            state.skills.map((li, i) => (
                              <option value={li.id}>{li.name}</option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.skill_id ? state.errors.skill_id : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 ">
                      <input
                        type="button"
                        name="submit"
                        value="Add Skill"
                        disabled={!trainerSkill.category_id ? true : false}
                        onClick={() => setSkillModel(true)}
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Total Experience
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainerSkill.experience}
                          onChange={(e) =>
                            setTrainerSkill({
                              ...trainerSkill,
                              experience: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.experience
                            ? state.errors.experience
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Type
                        </label>
                        <select
                          className="form-control"
                          name={"type"}
                          onChange={(e) =>
                            setTrainerSkill({
                              ...trainerSkill,
                              type: e.target.value,
                            })
                          }
                        >
                          <option>Select Type</option>
                          <option value={"Month"}>{"Month"}</option>
                          <option value={"Year"}>{"Year"}</option>
                        </select>
                        <span className="error-msg">
                          {state.errors.type ? state.errors.type : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cost Per Hours($)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainerSkill.rate_per_hours}
                          onChange={(e) =>
                            setTrainerSkill({
                              ...trainerSkill,
                              rate_per_hours: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.rate_per_hours
                            ? state.errors.rate_per_hours
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <input
                        onClick={() => handleFormSubmit()}
                        type="button"
                        name="submit"
                        value="Submit"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AddTrainerSkills;
